import { Brand, Schema } from '@blade/std-lib'

/**
 * Spelled out rather than imported from `@solana/web3.js`.
 *
 * It is a constant — a billion — and importing it brought the whole SDK,
 * six hundred kilobytes of it, into the chunk every session downloads.
 */
const LAMPORTS_PER_SOL = 1_000_000_000

export const LamportsTypeId = 'tradebot-tma/lamports'
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type LamportsTypeId = typeof LamportsTypeId

export type Lamports = Brand.Branded<number, LamportsTypeId>
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const Lamports = Brand.nominal<Lamports>()

export const LamportsSchema = Schema.Number.pipe(
  Schema.fromBrand(LamportsTypeId, Lamports),
)

export const MicroLamportsTypeId = 'tradebot-tma/microLamports'
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type MicroLamportsTypeId = typeof MicroLamportsTypeId

export type MicroLamports = Brand.Branded<number, MicroLamportsTypeId>
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MicroLamports = Brand.nominal<MicroLamports>()

export const MicroLamportsSchema = Schema.Number.pipe(
  Schema.fromBrand(MicroLamportsTypeId, MicroLamports),
)

export const solToLamports = (sol: number): Lamports =>
  Lamports(Math.round(sol * LAMPORTS_PER_SOL))

export const lamportsToMicroLamports = (lamports: Lamports): MicroLamports =>
  MicroLamports(Math.round(lamports * 1_000_000))
